import ProyectSuccesful from '../../../proyect-created/Index';

export const Finished = () => {
	return <ProyectSuccesful />;
};
